// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_d4-3";
export var flatBottomCorners = "_d4-5";
export var productImage = "_d4-0";
export var quantityContainer = "_d4-2";
export var quantityHeader = "_d4-6";
export var tooltip = "_d4-1";
export var wrapAndEllipsesOverflow = "_d4-4";